import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Checked from "./../assets/assets/check-circle.svg";
import File from "./../assets/assets/file.svg";
import Update from "./../assets/assets/update.svg";
import View from "./../assets/assets/view-icon.svg";
import DownloadIcon from "./../assets/assets/download.svg";
import { useSelector } from "react-redux";
import UserModal from "../components/EmailModal/UserModal";
import { uploadFile } from "./cloudinary";
import { callUrlFunction } from "./callUrlFunction";

// Shared URL helper (same as UpdateWidget)
function buildDerivedUrls(url) {
  const isPdf = !!url && /\.pdf($|\?)/i.test(url);

  if (!url) {
    return {
      fileResult: "",
      filePreview: "",
      fileEmbed: "",
      fileDownload: "",
      fileType: "",
    };
  }

  if (!isPdf) {
    return {
      fileResult: url,
      filePreview: url,
      fileEmbed: url,
      fileDownload: url,
      fileType: "image",
    };
  }

  const fileResult = url;
  const fileEmbed = url.replace("/raw/upload/", "/raw/upload/fl_inline/");
  const fileDownload = url.replace("/raw/upload/", "/raw/upload/fl_attachment/");
  const filePreview = url
    .replace("/raw/upload/", "/image/upload/pg_1,w_300/")
    .replace(/\.pdf($|\?)/i, ".jpg$1");

  return {
    fileResult,
    filePreview,
    fileEmbed,
    fileDownload,
    fileType: "pdf",
  };
}

const DeviceWidget = ({ title, handleDataFetch, handleRemoval, id, url, error, loaded, name }) => {
  const derived = buildDerivedUrls(url);

  const [state, setState] = useState({
    loaded: loaded || !!url,
    fileResult: derived.fileResult,
    filePreview: derived.filePreview,
    fileEmbed: derived.fileEmbed,
    fileDownload: derived.fileDownload,
    file_name: name || "",
    file_type: derived.fileType,
    showModal: false,
    previewBroken: false,
  });

  const success = useSelector((s) => s.pos.uploadSuccess);

  useEffect(() => {
    if (success) {
      setState({
        loaded: false,
        fileResult: "",
        filePreview: "",
        fileEmbed: "",
        fileDownload: "",
        file_name: "",
        file_type: "",
        showModal: false,
        previewBroken: false,
      });
    }
    // eslint-disable-next-line
  }, [success]);

  const showWidget = async () => {
    try {
      await uploadFile(callUrlFunction(handleDataFetch, id, setState, state));
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  const removeFile = () => {
    handleRemoval({ id, url: state.fileResult });
    setState((s) => ({
      ...s,
      fileResult: "",
      filePreview: "",
      fileEmbed: "",
      fileDownload: "",
      file_name: "",
      file_type: "",
      loaded: false,
      previewBroken: false,
    }));
  };

  const viewDoc = () => setState((s) => ({ ...s, showModal: true }));
  const closeDoc = () => setState((s) => ({ ...s, showModal: false }));

  const shortenName = (str) => (str?.length > 12 ? str.slice(0, 12) + "..." : str);

  return (
    <div className="upload-file">
      {state.loaded && (
        <>
          <div className="checked-upload">
            <img src={Checked} alt="checked" />
          </div>
          <div className="view-doc-upload">
            <div className="view-doc-upload-image" onClick={viewDoc}>
              <img src={View} alt="view" />
            </div>
            <span data-testid="viewDoc" onClick={viewDoc}>View</span>
            <div className="view-doc-upload-image" style={{ marginLeft: "1rem" }}>
              <a href={state.fileDownload || state.fileResult} download={state.file_name}>
                <img src={DownloadIcon} alt="download" />
              </a>
            </div>
            <span>
              <a href={state.fileDownload || state.fileResult} download={state.file_name}>
                Download
              </a>
            </span>
          </div>
        </>
      )}

      <h3>{title}</h3>

      <UserModal open={state.showModal} close={closeDoc} height="739" width="1000">
        <div style={{ padding: "20px" }}>
          <span className="iframe-back2" onClick={closeDoc} data-testid="closeDoc">X</span>
          {state.file_type === "pdf" ? (
            <>
              {!state.previewBroken && state.filePreview ? (
                <img
                  src={state.filePreview}
                  alt="PDF Preview"
                  style={{ width: "220px", marginBottom: "10px", border: "1px solid #eee" }}
                  onError={() => setState((s) => ({ ...s, previewBroken: true }))}
                />
              ) : (
                <div style={{ width: 220, height: 310, marginBottom: 10, border: "1px solid #eee", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span>Preview unavailable</span>
                </div>
              )}
              <embed src={state.fileEmbed || state.fileResult} width="100%" height="1000" title={name} type="application/pdf" />
              <div style={{ marginTop: 8 }}>
                <a href={state.fileResult} target="_blank" rel="noopener noreferrer">Open in new tab</a>
              </div>
            </>
          ) : (
            <img src={state.fileResult} alt={name} style={{ width: "100%", maxHeight: "1000px", objectFit: "contain" }} />
          )}
        </div>
      </UserModal>

      {!state.loaded ? (
        <div>
          <button data-testid="showWidget" onClick={showWidget}>+ &nbsp; &nbsp; CHOOSE FILE</button>
          {error && <span style={{ color: "red" }}>{error}</span>}
        </div>
      ) : (
        <div className="uploaded-file-doc">
          <span><img src={File} alt="file" /> &nbsp; {shortenName(state.file_name)}</span>
          <div className="icon-upload-flex" data-testid="removeFile" onClick={removeFile}>
            <div className="icon-upload"><img src={Update} alt="update" /></div>
            <h6>UPDATE / REMOVE</h6>
          </div>
        </div>
      )}
    </div>
  );
};

DeviceWidget.propTypes = {
  error: PropTypes.string,
  handleDataFetch: PropTypes.func,
  handleRemoval: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loaded: PropTypes.bool,
  name: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

export default DeviceWidget;
